export const Message = {
  ChangeBizType: 'ChangeBizType',
  ChangeActivityPlan: 'ChangeActivityPlan'
};
